import { TOKEN_KEY } from "./slice"

/** Given a `fetch` response, handles redirecting the
 * user to the sign-in page if server sends a 401 unauthorized,
 * otherwise simply returns the given response. */
export const handleSignIn = (response) => {
  if (!response.ok) {
    // Trap 401 and route user to login page
    if (response.status === 401) {
      if (console && console.warn) {
        console.warn(
          "Redirecting user to login page because 401 received: ",
          response
        )
      }
      // Prevent redirect loop
      if (window.location.href.indexOf("/login") == -1) {
        // Grab current location (react-router/history stack, not full URL)
        // and store in localStorage
        let currentLoc = `${window.location.pathname}${window.location.search}`
        // TODO this is a temp hack to get things working in prod (handle properly)
        let newCurrentLoc = currentLoc.replace("/synapse", "")
        localStorage.setItem("previousDestination", newCurrentLoc)
        // Hack to cater for the fact that in prod we might be prefixed
        // with /synapse - but in local dev we aren't.
        // Note: We don't use history.push but instead reload
        // the page, to also force client to refresh / update app.
        if (window.location.pathname.startsWith("/synapse")) {
          window.location.href = "/synapse/login"
        } else {
          window.location.href = "/login"
        }
      }
    }
    throw response
  }
  return response
}

/** Obtains the current user's token to authenticate
 * API calls with. */
export const getToken = () => localStorage.getItem(TOKEN_KEY)
